// extracted by mini-css-extract-plugin
export var bodyContainer = "YIPsO";